import { lpcoUtils } from ".";
import { FormControl, Group, Layout } from "@/comn/components";

//
export const MASK = {
    // TANSAD No !== TANSAD Number ==!
    TANSAD_NO: lpcoUtils.getMaskPattern("4-2-7", "-"),
    // Reference No !== 참조번호 ==!
    REFF_NO: lpcoUtils.getMaskPattern("9-2-7", "-"),
    // TIN !== Taxpayer Identification Number ==!
    TIN: lpcoUtils.getMaskPattern("3-3-3", "-"),
    // HS CODE !== HS Code ==!
    HS_CD: lpcoUtils.getMaskPattern("4-2-2-4", "."),
    // Cargo Reference Number !== 화물참조번호 ==!
    CRN: lpcoUtils.getMaskPattern("11-4", "-"),
    // Criteria Registration Number !== 선별 등록 번호 ==!
    CRTR_REG_NO: lpcoUtils.getMaskPattern("2-4-4-5", "-"),
    // Unique Consignment Reference Number !== UCR 번호 ==!
    UCR_NO: lpcoUtils.getMaskPattern("2-2-9-1-3-10-1", "-"),
    // BILL NUMBER !==고지번호==!
    BLL_NO: lpcoUtils.getMaskPattern("4-2-1-7-1", "-"),
};

export const APP_CD_NO = {
    // ZBS Clearance Permit — 비규제(NR) 승인 권한이 VA 단계에 있는 신청서 !== ZBS Clearance Permit ==!
    ZBS_CLEARANCE: "OGAZ0001SW0003",
};
